import isTouch from 'static/script/utils/is-touch';
import defineComponent from 'flight';

function ShowAllFiltersUI() {
    this.defaultAttrs({
        showAllButton: '[data-tag-navigation-filter-show-all]',
        showAllButtonTypeData: 'tag-navigation-filter-show-all',
        showAllButtonPlaceholderData: 'tag-modal-search-placeholder'
    });

    this._triggerModal = function(evt, payload) {
        let $payloadEl = $(payload.el);
        let modalType = $payloadEl.data(this.attr.showAllButtonTypeData);
        let placeholder = $payloadEl.data(
            this.attr.showAllButtonPlaceholderData
        );
        let options = {
            cssClass: 'modal-tags',
            placeholder: placeholder,
            parentNode: this.$node,
            modalType: modalType
        };

        this.trigger(document, 'analytics:track-event', {
            category: 'Search Filters',
            action: 'Tag Navigation',
            label: 'Show all modal - ' + modalType,
            userTriggered: true
        });

        this.trigger(document, 'ui:search-result:on-open-filters', options);
    };

    // this._getSearchFilterContent = function (options) {
    //     return JST['templates/filter-tags-input-template.html']({placeholder: options.placeholder});
    // };

    // this._getContent = function (options) {
    //     var list = this._getListContent(),
    //         filterInput = this._getSearchFilterContent(options),
    //         content = $('<div class="tag-modal-content"></div>');

    //     return content
    //         .append(filterInput)
    //         .append(list);
    // };

    // this._getListContent = function () {
    //     var sorter = function (a, b) {
    //         var aTxt = $(a).find('.search-filters-list-item-label')[0].innerHTML.toUpperCase(),
    //             bTxt = $(b).find('.search-filters-list-item-label')[0].innerHTML.toUpperCase();

    //         if (aTxt < bTxt) {
    //             return -1;
    //         } else if (aTxt > bTxt) {
    //             return 1;
    //         }
    //         return 0;
    //     };
    //     var ol = $('<ol class="tag-modal-list"></ol>');
    //     var list = this.select('tagListSelector').clone();
    //     return ol.append(list.sort(sorter));
    // };

    this.after('initialize', function() {
        this.on('click', {
            showAllButton: this._triggerModal
        });
    });
}

export default defineComponent.component(ShowAllFiltersUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/show-all-filters-ui.js